import React,{useContext,createContext} from 'react';
export const MessageContext = createContext();